export const updateReadConv = (data: any, groupI: number, convI: number) => {
  data[groupI].conversations[convI].hasUnreadMessages = false;

  const names = data[groupI].conversations[convI].displayName.split(" (New");

  data[groupI].conversations[convI].displayName = names[0];
};
